import './tab-bar.css';
import React, { useEffect, useState } from 'react';
import { TabPanel, TabView } from 'primereact/tabview';

interface TabBarDataModel {
  tabs: string[];
  onClick: (index: number) => void;
  disable?: boolean;
  activeIndex?: number;
}

const TabBar: React.FC<TabBarDataModel> = ({
  tabs,
  onClick,
  disable = false,
  activeIndex,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const resolvedActiveIndex = activeIndex ?? selectedIndex;

  useEffect(() => {
    if (activeIndex == null) return;
    setSelectedIndex(activeIndex);
  }, [activeIndex]);

  return (
    <div className={'tab-bar-root-column'}>
      <div className={'tab-bar-root-row'}>
        <TabView
          color={'green'}
          style={{ width: '100%' }}
          className={'p-tabview'}
          activeIndex={resolvedActiveIndex}
          onTabChange={(e) => {
            onClick(e.index);
            setSelectedIndex(e.index);
          }}
        >
          {tabs.map((item, index) => (
            <TabPanel disabled={disable} key={index} header={item} />
          ))}
        </TabView>

        {/*{tabs.map((item, index) => (
          <div
            onClick={() => {
              setSelectedIndex(index);
              onClick(index);
            }}
            className={'tab-bar-root-column'}
          >
            <div
              className={
                index === selectedIndex
                  ? 'tab-bar-item-selected'
                  : 'tab-bar-item'
              }
              key={index}
            >
              {item}
              {index === selectedIndex && (
                <div className={'tab-bar-item-under-line'}></div>
              )}
            </div>
          </div>
        ))}*/}
      </div>
      {/*<div className={'tab-bar-item-line'}></div>*/}
    </div>
  );
};

export default TabBar;
